export const OriginEnum = Object.freeze({
    BLINGV3: "blingV3",
    // BRCOMERCE: "brcomerce",
    NUVEMSHOP: "nuvemshop",
    TRAY: "tray",
    TRAYCORP: "traycorp",
    VTEX: "vtex",
    WOOCOMMERCE: "woocommerce",
    YAMPI: "yampi",
    VNDA: "vnda",
    TINY: "tiny",
    APP: "app",
    INTEGRATION: "integration",
    INTELIPOST: "intelipost",
    ABBIAMO: "abbiamo",
    BAGY: "bagy",
    PROCEDA: "proceda"
});
